import styled from 'styled-components'
import { space } from 'styled-system'

import { default as VARIABLES } from '../../themes/styles/variables'

export const TaskBlockStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  flex: 0 0 332px;
  width: 332px;
  padding: 24px 30px;
  align-items: center;
  background-color: ${VARIABLES.COLORS.BLUE_1};
  color: white;
  font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
  border-radius: ${VARIABLES.BORDER_RADIUSES.LG};
  margin-right: 35px;
  margin-bottom: 35px;
  cursor: pointer;

  /* Styled System
  ------------------------------- */
  ${space} /* */

  /* Child element styles
  ------------------------------- */
  .task-number {
    /* flex: 0 0 80px;
    margin-right: 10px; */
    flex: 0 0 auto;
    padding-right: 15px;
    font-size: 34px;
  }

  .task-text {
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.LG};
    text-align: right;
    flex: 1 1 auto;
  }

  /* Modifiers
  ------------------------------- */
  &.fluid {
    width: auto;
    display: inline-flex;

    .task-text {
      white-space: nowrap;
      /* margin-right: 22px; */
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
    flex: 0 0 290px;
    padding: 20px 25px;
    margin: 0 30px 30px 0;

    .task-number {
      font-size: 32px;
    }

    .task-text {
      font-size: 18px;
    }
  }

  @media all and (max-width: 1366.98px) {
    flex: 0 0 260px;
    margin: 0 25px 25px 0;

    .task-number {
      font-size: 30px;
    }

    .task-text {
      font-size: 16px;
    }
  }

  @media all and (max-width: 1280.98px) {
    flex: 0 0 230px;
    padding: 15px;
    margin: 0 15px 15px 0;

    .task-number {
      font-size: 28px;
    }

    .task-text {
      font-size: 14px;
    }
  }

  @media all and (max-width: 1024.98px) {
    flex: 0 0 210px;

    .task-number {
      font-size: 26px;
    }

    .task-text {
      font-size: 12px;
    }
  }
`
